'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Immutable = require('Immutable');

var _eventPropTypes = require('event-tracking-tools/events/eventPropTypes');

var _eventPropTypes2 = _interopRequireDefault(_eventPropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AmplitudeEventRecord = (0, _Immutable.Record)({
  // Event-level strict check. If true, events will fail if they don't match.
  // If false, the events will throw a warning to the console.
  useStrict: false,

  // The top-level grouping that the event will fall under
  namespace: null,

  // Effectively, the name of the event
  action: null,

  // The only way to persist where_screen/where_subscreen is to trigger VIEW
  // event types. Screen/location will be passed as normal in extra_json.
  // Not that big of a deal unless you are attempting backward compatibility
  // with hublytics router tracking (you'll still have to use the old
  // where_screen/where_subscreen properties, as new ones don't persist).
  isViewEvent: false,

  // Validation for the top-level record props.
  // Because the record sets default values and drops unexpected props,
  // this is needed as a "hidden" property.
  __propTypes__: {
    namespace: _eventPropTypes2.default.STRING,
    action: _eventPropTypes2.default.STRING,
    isViewEvent: _eventPropTypes2.default.BOOLEAN
  },

  // Arbitrary propTypes that can have a validator or default value.
  // You can also specify some types using eventPropTypes
  // otherwise they always default to eventPropTypes.REQUIRED
  propTypes: {}

}, 'AmplitudeEventRecord');

AmplitudeEventRecord.debugName = 'AmplitudeEventRecord';

exports.default = AmplitudeEventRecord;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/event-tracking-tools/static-1.15/js/records/AmplitudeEventRecord.js
// module id = 540
// module chunks = 0